import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import "./Overview.css";
import ReviewGraph from "../../components/reviewGraph/reviewGraph";
import CountGraph from "../../components/countGraph/countGraph";
import NegativeReviews from "../../components/negativeReviews/negativeReviews";
import AnalysisGraph from "../../components/analysisGraph/analysisGraph";
import ComparisonGraph from "../../components/comparisonGraph/comparisonGraph";

const Overview = () => {
  const [selectedGraph, setSelectedGraph] = useState("average");
  const [showSpinner, setShowSpinner] = useState(true);
  const { reviews, loading, error } = useSelector((state) => state.reviews);
  const [sp] = useSearchParams();
  const type = sp.get("type") === "private" ? "private" : "group";

  useEffect(() => {
    // Show spinner for a brief period when page mounts or type changes
    setShowSpinner(true);
    const timer = setTimeout(() => setShowSpinner(false), 300); // optional: minimal delay
    return () => clearTimeout(timer);
  }, [type]);

  // Show loading only if Redux loading is true
  if (loading || showSpinner) {
    return (
      <div className="loading">
        <div className="lds-roller">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    );
  }

  if (error) {
    return <p>Error loading data: {String(error)}</p>;
  }

  return (
    <div className="overviewConatiner">
      <div className="overviewGraphContainer">
        <div className="chartHeadingContainer">
          <div className="chartHeading">Chart Options</div>
          <select
            onChange={(e) => setSelectedGraph(e.target.value)}
            value={selectedGraph}
          >
            <option value="average">Average Graph</option>
            <option value="count">Review Count</option>
          </select>
        </div>
        <div className="graph-container">
          {selectedGraph === "average" ? (
            <ReviewGraph reviewData={reviews || []} />
          ) : (
            <CountGraph reviewData={reviews || []} />
          )}
        </div>
      </div>

      <div className="analysisGraphContainer">
        <AnalysisGraph reviews={reviews || []} />
      </div>
      <div>
        <ComparisonGraph reviews={reviews || []} />
      </div>
      <div className="negativeReviewsConatiner">
        <NegativeReviews />
      </div>
    </div>
  );
};

export default Overview;
